import React from 'react';

import { Icon } from '@fragment/ui/src/components/Icon';
import type {
  TWBackgroundProp,
  TWTextColorProp,
} from '@fragment/ui/src/types/tailwind';

export const ExternalLink = <BackgroundProp, TextColorProp>({
  label,
  href,
  background,
  color,
  showExternalIcon = true,
}: {
  label: string;
  href: string;
  background?: TWBackgroundProp<BackgroundProp>;
  color?: TWTextColorProp<TextColorProp>;
  showExternalIcon?: boolean;
}) => (
  <a
    className={`${background ?? 'bg-main-200 hover:bg-negative'} ${
      color ?? ''
    }`}
    href={href}
    target="_blank"
    rel="noreferrer"
  >
    <span>{label}</span>
    {showExternalIcon && (
      <Icon
        type="external"
        primaryColor={color !== undefined ? undefined : 'gray'}
        size="md"
      />
    )}
  </a>
);
